import { merge } from 'lodash'
import Noty from 'noty'
import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'
import router from '@/router'
import $ from 'jquery'
import store from '../vuex/store'

export default {

  /**
   * Create a success notification.
   *
   * @param string text
   * @param object options
   *
   * @return Noty
   */
  success (text, options = {}) {
    return this.notification(merge({
      type: 'success',
      text
    }, options))
  },

  systemNotif (text, link, options = {}) {
    return this.notification(merge({
      type: 'info',
      text,
      closeWith: ['click'],
      callbacks: {
        onClick: function () {
          if (link) {
            router.push(link)
          }
        }
      }
    }))
  },

  messageNotif (text, threadId, messageId, userId, unreadCount, tenantSlug) {
    return this.notification(merge({
      type: 'info',
      text,
      closeWith: ['click', 'button'],
      callbacks: {
        onClick: function () {
          if (threadId) {
            $('.drawer-messages').drawer('show')
            const targetElement = document.getElementById('mainbody')
            targetElement.style.overflow = 'hidden'
            store.dispatch('message/getThread', { threadId, tenantSlug }).then(() => {
              store.dispatch('message/markAllMessagesRead', { threadId: threadId, messageId: messageId, userId: userId, count: unreadCount, tenantSlug })
            })
          }
        }
      }
    }))
  },

  /**
   * Create a warning notification.
   *
   * @param string text
   * @param object options
   *
   * @return Noty
   */
  warning (text, options = {}) {
    return this.notification(merge({
      type: 'warning',
      text
    }, options))
  },

  /**
   * Create an error notification.
   *
   * @param string text
   * @param object options
   *
   * @return Noty
   */
  error (text, options = {}) {
    return this.notification(merge({
      type: 'error',
      text
    }, options))
  },

  /**
   * Create an info notification.
   *
   * @param string text
   * @param object options
   *
   * @return Noty
   */
  info (text, options = {}) {
    return this.notification(merge({
      type: 'info',
      text
    }, options))
  },

  /**
   * Create a Noty notification with the given options.
   *
   * @param object options
   *
   * @return Noty
   */
  notification (options = {}) {
    return new Noty(merge({
      theme: 'metroui',
      timeout: 3000,
      progressBar: true,
      animation: {
        open: function (promise) {
          Velocity(this.barDom, 'transition.slideRightIn', {
            duration: 500,
            complete: function () {
              promise(function (resolve) {
                resolve()
              })
            }
          })
        },

        close: function (promise) {
          Velocity(this.barDom, 'transition.slideRightOut', {
            duration: 500,
            complete: function () {
              promise(function (resolve) {
                resolve()
              })
            }
          })
        }
      }
    }, options)).show()
  }
}
